import { ApiFrontendConfigurationRetrieve200 } from '@rover/rsdk/src/apiClient/latest';
import { PriceTransparencyLevels } from '@rover/types/src/PriceTransparencyLevel';

export default function fetchFrontendConfigurationResponseFactory(
  opts?: Partial<ApiFrontendConfigurationRetrieve200>
): ApiFrontendConfigurationRetrieve200 {
  return {
    flags: {},
    settings: {
      branchKey: '',
      ccTld: '',
      countryCode: '',
      csrfCookieName: '',
      dogSizeBuckets: {
        // We add defaults here because the a11y PR check fails if the labels are blank
        small: '0-15',
        medium: '16-40',
        large: '41-100',
        giant: '101+',
      },
      googleMapsClientId: '',
      gtmContainerId: '',
      imageUploadMaxSize: 0,
      isBeforeHoliday: false,
      language: '',
      personReferralAccount: '',
      personReferralCampaign: '',
      priceTransparencyLevel: PriceTransparencyLevels.none,
      staticSvgPresent: '',
      supportsMobileApp: false,
      supportsReferral: false,
      weightUnit: '',
      staticGoogleMapsApiKey: '',
      sessionReplaySampleRate: 0,
    },
    ...opts,
  };
}
